<div id="upload-image-mobile" class="h-100">

  <div>
    <kl-add-project-members [projectId]="projectId" (addedMembers)="onAddingMembers($event)">
    </kl-add-project-members>
  </div>

</div>
